<template>
  <el-select
    v-model="drivetrainModel"
    @change="drivetrainsChanged"
    :placeholder="this.placeholder ?? $t('DRIVETRAIN.DRIVETRAIN')"
    :filterable="filterable"
    :disabled="disabled"
    multiple
  >
    <el-option v-if="allowNone" :value="null" :label="$t('COMMON.NONE')" />
    <el-option
      v-for="option in drivetrainOptionsArray"
      :key="option.value"
      :value="option.value"
      :label="option.label"
    />
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";
import { drivetrainOptions } from "../constants/drivetrain";

export default {
  name: "drivetrains-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    value: {
      type: String | Number | null | undefined,
      default: null,
      description: "Value",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Allow null value",
    },
    placeholder: {
      type: String,
      default: null,
      description: "Placeholder",
    },
  },

  data() {
    let drivetrainModel = null;
    if (this.value) {
      drivetrainModel = this.value?.map((value) => value?.toLowerCase());
    }
    return {
      drivetrainModel,
      drivetrainOptions,
    };
  },

  setup() {},

  created() {},

  computed: {
    drivetrainOptionsArray: function () {
      return Object.entries(this.drivetrainOptions).map(([key, value]) => ({
        value,
        label: this.label(key),
      }));
    },
  },

  methods: {
    drivetrainsChanged(drivetrains) {
      this.$emit("drivetrainsChanged", drivetrains);
    },
    label(option) {
      return this.$tc(`DRIVETRAIN.DRIVETRAIN_${option.toUpperCase()}`)
        ? this.$t(`DRIVETRAIN.DRIVETRAIN_${option.toUpperCase()}`)
        : option;
    },
  },

  watch: {
    value() {
      this.drivetrainModel = this.value?.map((value) => value?.toLowerCase());
    },
  },
};
</script>
